const question = {
    important: { point: [1], rejectedProfiles: ['D'] },
    moderate: { point: [2] },
    none: { point: [3] },
};

export default question;
